<template>
  <div class="text-h4">
    <v-row>
      <v-col cols="7">
        <apexchart class="flex-grow-1" type="bar" height="500" :options="confGraficaPiezas"
          :series="seriesGraficaPiezas" />
      </v-col>
      <!-- Datos en tiempo real -->
      <v-col cols="5" class="d-flex" v-if="isFechaActual && isHoraEnRango">
        <v-row>
          <v-col cols="12">
            <v-card color="success darken-1" dark>
              <v-card-title class="text-center d-flex justify-center"
                style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                Piezas OK de la hora
              </v-card-title>
              <div>
                <v-row>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Derecha
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Izquierda
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Resumen
                  </v-col>
                </v-row>
              </div>
              <div>
                <v-row>
                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ franjaActual.pzaRealizadas }} / {{ franjaActual.pzaTeoricas }}
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ franjaActual.pzaRealizadasIzq }} / {{ franjaActual.pzaTeoricasIzq }}
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ franjaActual.pzaRealizadas + franjaActual.pzaRealizadasIzq }}
                    /
                    {{ franjaActual.pzaTeoricas + franjaActual.pzaTeoricasIzq }}
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <v-card color="error darken-1" class="mt-5" dark>
              <v-card-title class="text-center d-flex justify-center"
                style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                Piezas NO OK de la hora
              </v-card-title>
              <div>
                <v-row>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Derecha
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Izquierda
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Resumen
                  </v-col>
                </v-row>
              </div>
              <div>
                <v-row>
                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ franjaActual.pzaNoOk }} / {{ franjaActual.pzaRealizadas }}
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ franjaActual.pzaNoOkIzq }} / {{ franjaActual.pzaRealizadasIzq }}
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ franjaActual.pzaNoOk + franjaActual.pzaNoOkIzq }}
                    /
                    {{ franjaActual.pzaRealizadas + franjaActual.pzaRealizadasIzq }}
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <v-card color="primary darken-1" class="mt-5">
              <v-card-title class="text-center d-flex justify-center white--text"
                style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                Resumen hasta ahora
              </v-card-title>
              <v-card-text>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th class="text-center">Tipo</th>
                      <th class="text-center font-weight-bold">Derecha</th>
                      <th class="text-center font-weight-bold">Izquierda</th>
                      <th class="text-center font-weight-bold">Resumen</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Fila de OK -->
                    <tr>
                      <td class="text-center">OK</td>
                      <td class="text-center font-weight-bold">
                        {{ franjaActual.pzaRealizadasAcumulado }} / {{ franjaActual.pzaTeoricasAcumulado }}
                      </td>
                      <td class="text-center font-weight-bold">
                        {{ franjaActual.pzaRealizadasAcumuladoIzq }} / {{ franjaActual.pzaTeoricasAcumuladoIzq }}
                      </td>
                      <td class="text-center font-weight-bold">
                        {{ (franjaActual.pzaRealizadasAcumulado || 0)
                          + (franjaActual.pzaRealizadasAcumuladoIzq || 0) }}
                        /
                        {{ (franjaActual.pzaTeoricasAcumulado || 0)
                          + (franjaActual.pzaTeoricasAcumuladoIzq || 0) }}
                      </td>
                    </tr>
                    <!-- Fila de NO OK -->
                    <tr>
                      <td class="text-center">NO OK</td>
                      <td class="text-center font-weight-bold">
                        {{ franjaActual.pzaNoOkAcomulado }}
                        /
                        {{ franjaActual.pzaRealizadasAcumulado }}
                      </td>
                      <td class="text-center font-weight-bold">
                        {{ franjaActual.pzaNoOkAcomuladoIzq }}
                        /
                        {{ franjaActual.pzaRealizadasAcumuladoIzq }}
                      </td>
                      <td class="text-center font-weight-bold">
                        {{ (franjaActual.pzaNoOkAcomulado || 0) + (franjaActual.pzaNoOkAcomuladoIzq || 0) }}
                        /
                        {{ (franjaActual.pzaRealizadasAcumulado || 0) + (franjaActual.pzaRealizadasAcumuladoIzq || 0) }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
            <v-row class="mt-5">
              <v-col cols="6">
                <v-card color="primary" dark height="140">
                  <v-card-title class="justify-center text-center">
                    OEE Acumulado
                  </v-card-title>
                  <v-card-text class="d-flex justify-center align-center text-h5 white--text font-weight-bold">
                    {{ ((dataHoras[dataHoras.length - 1] && dataHoras[dataHoras.length - 1].oee) || 0).toFixed(2) }}
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="6">
                <v-card color="primary" dark height="140">
                  <v-card-title class="justify-center text-center">
                    Tiempo Muerto Acumulado
                  </v-card-title>
                  <v-card-text class="d-flex justify-center align-center text-h5 white--text font-weight-bold">
                    {{ ((dataHoras[dataHoras.length - 1] && dataHoras[dataHoras.length - 1].tiempoParo) || 0).toFixed(2)
                    }} Min
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- Datos historicos -->
      <v-col cols="5" class="d-flex" v-else>
        <v-row>
          <v-col cols="12">
            <v-card color="success darken-1" dark>
              <v-card-title class="text-center d-flex justify-center"
                style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                Piezas OK del turno
              </v-card-title>
              <div>
                <v-row>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Derecha
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Izquierda
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Resumen
                  </v-col>
                </v-row>
              </div>
              <div>
                <v-row>
                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ formatNumber(dataHoras[dataHoras.length - 1].pzaRealizadasAcumulado) }}
                    /
                    {{ formatNumber(dataHoras[dataHoras.length - 1].pzaTeoricasAcumulado) }}
                  </v-col>

                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ formatNumber(dataHoras[dataHoras.length - 1].pzaRealizadasAcumuladoIzq) }}
                    /
                    {{ formatNumber(dataHoras[dataHoras.length - 1].pzaTeoricasAcumuladoIzq) }}
                  </v-col>

                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ formatNumber(
                      dataHoras[dataHoras.length - 1].pzaRealizadasAcumulado +
                      dataHoras[dataHoras.length - 1].pzaRealizadasAcumuladoIzq
                    ) }}
                    /
                    {{ formatNumber(
                      dataHoras[dataHoras.length - 1].pzaTeoricasAcumulado +
                      dataHoras[dataHoras.length - 1].pzaTeoricasAcumuladoIzq
                    ) }}
                  </v-col>
                </v-row>

              </div>
            </v-card>
            <v-card color="error darken-1" class="mt-5" dark>
              <v-card-title class="text-center d-flex justify-center"
                style="white-space: normal; word-break: normal; overflow-wrap: break-word;">
                Piezas NO OK del turno
              </v-card-title>
              <div>
                <v-row>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Derecha
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Izquierda
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center text-subtitle-2">
                    Resumen
                  </v-col>
                </v-row>
              </div>
              <div>
                <v-row>
                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ formatNumber(dataHoras[dataHoras.length - 1].pzaNoOkAcomulado) }}
                    /
                    {{ formatNumber(dataHoras[dataHoras.length - 1].pzaRealizadasAcumulado) }}
                  </v-col>

                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ formatNumber(dataHoras[dataHoras.length - 1].pzaNoOkAcomuladoIzq) }}
                    /
                    {{ formatNumber(dataHoras[dataHoras.length - 1].pzaRealizadasAcumuladoIzq) }}
                  </v-col>

                  <v-col cols="4" class="d-flex justify-center text-h6 font-weight-bold">
                    {{ formatNumber(
                      dataHoras[dataHoras.length - 1].pzaNoOkAcomulado +
                      dataHoras[dataHoras.length - 1].pzaNoOkAcomuladoIzq
                    ) }}
                    /
                    {{ formatNumber(
                      dataHoras[dataHoras.length - 1].pzaRealizadasAcumulado +
                      dataHoras[dataHoras.length - 1].pzaRealizadasAcumuladoIzq
                    ) }}
                  </v-col>
                </v-row>

              </div>
            </v-card>
            <v-row class="mt-5">
              <v-col cols="6">
                <v-card color="primary" dark height="140">
                  <v-card-title class="justify-center text-center">
                    OEE Acumulado
                  </v-card-title>
                  <v-card-text class="d-flex justify-center align-center text-h5 white--text font-weight-bold">
                    {{ ((dataHoras[dataHoras.length - 1] && dataHoras[dataHoras.length - 1].oee) || 0).toFixed(2) }}
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="6">
                <v-card color="primary" dark height="140">
                  <v-card-title class="justify-center text-center">
                    Tiempo Muerto Acumulado
                  </v-card-title>
                  <v-card-text class="d-flex justify-center align-center text-h5 white--text font-weight-bold">
                    {{ ((dataHoras[dataHoras.length - 1] && dataHoras[dataHoras.length - 1].tiempoParo) || 0).toFixed(2)
                    }} Min
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    fecha: String,
    cantidadCavidades: {type: Number, default: 2}
  },
  data() {
    return {
      pastelPiezasT: {
        chart: {
          // width: "100%",
          type: 'pie',
        },
        labels: ['Buenas', 'Retrabajo', 'Scrap'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              // width: 200
            },
          }
        }],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        }
      },
    }
  },
  computed: {
    dataHoras() {
      if (!this.value) return [];
      return this.value.horas;
    },
    isFechaActual() {
      if (!this.value) return
      const hoy = new Date()
      const pad = n => String(n).padStart(2, '0')
      const hoyStr = [
        hoy.getFullYear(),
        pad(hoy.getMonth() + 1),
        pad(hoy.getDate())
      ].join('-')

      return this.fecha === hoyStr
    },
    isHoraEnRango() {
      const franjas = this.dataHoras || []
      if (!franjas.length) return false

      const now = new Date()
      const minutosAhora = now.getHours() * 60 + now.getMinutes()

      const toMin = s => {
        const [h, m] = s.split(':').map(Number)
        return h * 60 + m
      }

      return franjas.some(f =>
        minutosAhora >= toMin(f.desdeHora) &&
        minutosAhora < toMin(f.hastaHora)
      )
    },
    franjaActual() {
      const horas = this.dataHoras || []
      if (!horas.length) return null

      const ahora = new Date()
      const minutosAhora = ahora.getHours() * 60 + ahora.getMinutes()

      const toMin = str => {
        const [h, m] = str.split(':').map(Number)
        return h * 60 + m
      }

      return (
        horas.find(f =>
          minutosAhora >= toMin(f.desdeHora) &&
          minutosAhora < toMin(f.hastaHora)
        ) || null
      )
    },

    horasText() {
      if (!this.dataHoras) return [];
      const horarios = this.dataHoras.map(item => `${item.desdeHora} - ${item.hastaHora}`);
      return horarios;
    },

    pzaRealizadasDer() {
      const data = this.dataHoras ? this.dataHoras : [];
      return data.map(h => h.pzaRealizadas)
    },
    pzaEsperadasDer() {
      const data = this.dataHoras ? this.dataHoras : [];
      return data.map(h => h.pzaTeoricas)
    },
    pzaFaltantesDer() {
      const data = this.dataHoras || [];
      return data.map(h => {
        const teoricoProm = (h.pzaTeoricas + h.pzaTeoricasIzq) / this.cantidadCavidades;
        return Math.max(0, teoricoProm - h.pzaRealizadas);
      });
    },
    pzaRealizadasIzq() {
      const data = this.dataHoras ? this.dataHoras : [];
      return data.map(h => h.pzaRealizadasIzq)
    },
    pzaEsperadasIzq() {
      const data = this.dataHoras ? this.dataHoras : [];
      return data.map(h => h.pzaTeoricasIzq)
    },
    pzaFaltantesIzq() {
      const data = this.dataHoras || [];
      return data.map(h => {
        const teoricoProm = (h.pzaTeoricas + h.pzaTeoricasIzq) / this.cantidadCavidades;
        return Math.max(0, teoricoProm - h.pzaRealizadasIzq);
      });
    },
    pzaTeoricas() {
      const data = this.dataHoras ? this.dataHoras : [];
      return data.map(h => Math.floor((h.pzaTeoricas + h.pzaTeoricasIzq) / this.cantidadCavidades))
    },
    barPiezas() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true
        },
        stroke: {
          // 6 columnas con width 1; línea con width 4
          width: [1, 1, 1, 1, 1, 1, 15],
          curve: 'smooth',
          colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#FEB019', '#FEB019']
        },
        dataLabels: {
          enabled: true,
          formatter: val => val
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        xaxis: {
          categories: this.horasText,
        },
        fill: {
          opacity: 1
        },
        colors: [
          '#008FFB', // Buenas derecha
          '#00E396', // Buenas Izquierda
          '#F15B46', // Malas Derecha
          '#F15B46', // Malas Izquierda
          '#993981', // Faltantes Derecha
          '#993981', // Faltantes Izquierda
          '#FEB019'  // Esperado
        ],
        yaxis: {
          labels: {
            formatter: val => val
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        },
        tooltip: {
          shared: true,
          intersect: false
        }
      }
    },
    seriesPiezas() {
      const malasFalsasDer = this.dataHoras.map(() => 0)
      const malasFalsasIzq = this.dataHoras.map(() => 0)

      return [
        {
          name: 'Piezas Izquierda',
          group: 'budget',
          type: 'column',
          data: this.pzaRealizadasIzq
        },
        {
          name: 'Piezas Derecha',
          group: 'actual',
          type: 'column',
          data: this.pzaRealizadasDer
        },
        {
          name: 'Piezas Izquierda Malas',
          group: 'budget',
          type: 'column',
          data: malasFalsasIzq
        },
        {
          name: 'Piezas Derecha Malas',
          group: 'actual',
          type: 'column',
          data: malasFalsasDer
        },
        {
          name: 'Faltantes Izquierda',
          group: 'budget',
          type: 'column',
          data: this.pzaFaltantesIzq
        },
        {
          name: 'Faltantes Derecha',
          group: 'actual',
          type: 'column',
          data: this.pzaFaltantesDer
        },
        {
          name: 'Esperado',
          type: 'line',
          data: this.pzaTeoricas
        }
      ]
    },

    pzaRealizadasT() {
      const data = this.dataHoras ? this.dataHoras : [];
      return data.map(h => h.pzaRealizadas + h.pzaRealizadasIzq)
    },
    pzaFaltantesT() {
      const data = this.dataHoras || [];
      return data.map(h => {
        const teoricoProm = (h.pzaTeoricas + h.pzaTeoricasIzq);
        return Math.max(0, teoricoProm - (h.pzaRealizadas + h.pzaRealizadasIzq));
      });
    },
    pzaTeoricasT() {
      const data = this.dataHoras ? this.dataHoras : [];
      return data.map(h => (h.pzaTeoricas + h.pzaTeoricasIzq))
    },
    barPiezasT() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true
        },
        stroke: {
          // 6 columnas con width 1; línea con width 4
          width: [1, 1, 1, 15],
          curve: 'smooth',
          colors: ['#fff', '#fff', '#fff', '#FEB019']
        },
        dataLabels: {
          enabled: true,
          formatter: val => val
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        xaxis: {
          categories: this.horasText,
        },
        fill: {
          opacity: 1
        },
        colors: [
          '#008FFB', // Buenas derecha
          '#F15B46', // Malas Derecha
          '#993981', // Faltantes Derecha
          '#FEB019'  // Esperado
        ],
        yaxis: {
          labels: {
            formatter: val => val
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        },
        tooltip: {
          shared: true,
          intersect: false
        }
      }
    },
    seriesPiezasT() {
      const malasFalsasT = this.dataHoras.map(() => 0)
      return [
        {
          name: 'Piezas Hechas',
          group: 'budget',
          type: 'column',
          data: this.pzaRealizadasT
        },
        {
          name: 'Piezas Malas',
          group: 'budget',
          type: 'column',
          data: malasFalsasT
        },
        {
          name: 'Faltantes',
          group: 'budget',
          type: 'column',
          data: this.pzaFaltantesT
        },
        {
          name: 'Esperado',
          type: 'line',
          data: this.pzaTeoricasT
        }
      ]
    },

    confGraficaPiezas() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          events: {
            mounted(chartContext) {
              chartContext.hideSeries('Faltantes Derecha')
              chartContext.hideSeries('Faltantes Izquierda')
            }
          },
        },
        stroke: {
          width: [1, 1, 1, 1, 1, 1, 3],        // 6×1 para columnas, 1×4 para la línea
          colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#FEB019']  // 6 blancos + 1 color para la línea
        },
        markers: {
          size: 15,                       // círculos de 4px de radio
          colors: ['#FEB019'],           // color de relleno
          strokeColors: ['#fff'],        // color de borde
          strokeWidth: 0,                // grosor del borde
          hover: { sizeOffset: 2 }       // efecto al pasar el ratón
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#000'],    // rojo (puede ser array con varios colores o un solo string)
            fontSize: '54px',       // tamaño de fuente
            fontWeight: '900',      // grosor opcional
            fontFamily: 'Arial, sans-serif'
          },
          formatter: val => val
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '120%',
            endingShape: 'rounded'
          }
        },
        xaxis: {
          categories: this.horasText,
        },
        fill: {
          opacity: 1
        },
        colors: [
          '#008FFB', // Buenas derecha
          '#00E396', // Buenas Izquierda
          '#F15B46', // Malas Derecha
          '#F15B46', // Malas Izquierda
          '#993981', // Faltantes Derecha
          '#993981', // Faltantes Izquierda
          '#FEB019'  // TEAM C
        ],
        yaxis: {
          // labels: {
          //   formatter: val => val
          // }
          labels: {
            style: {
              fontSize: '54px',   // tamaño de los ticks del eje Y
              colors: '#333'
            }
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        },
        tooltip: {
          shared: true,
          intersect: false
        }
      }
    },
    seriesGraficaPiezas() {
      const asInt = n => (n == null || isNaN(n) ? 0 : Math.round(Number(n)));
      const asFix2 = n => (n == null || isNaN(n) ? 0 : Number(Number(n).toFixed(2)));

      const derReal = (this.pzaRealizadasDer ?? []).map(asInt);
      const izqReal = (this.pzaRealizadasIzq ?? []).map(asInt);
      const faltDer = (this.pzaFaltantesDer ?? []).map(asInt);
      const faltIzq = (this.pzaFaltantesIzq ?? []).map(asInt);
      const esperado = (this.pzaTeoricas ?? []).map(asFix2);

      // “malas” falsas siguen en cero con el mismo largo
      const malasFalsasDer = derReal.map(() => 0);
      const malasFalsasIzq = izqReal.map(() => 0);

      return [
        { name: 'Piezas Derecha', group: 'derecha', type: 'column', data: derReal },
        { name: 'Piezas Izquierda', group: 'izquierda', type: 'column', data: izqReal },
        { name: 'Piezas Derecha Malas', group: 'derecha', type: 'column', data: malasFalsasDer },
        { name: 'Piezas Izquierda Malas', group: 'izquierda', type: 'column', data: malasFalsasIzq },
        { name: 'Faltantes Derecha', group: 'derecha', type: 'column', data: faltDer },
        { name: 'Faltantes Izquierda', group: 'izquierda', type: 'column', data: faltIzq },
        { name: 'Esperado', type: 'line', data: esperado }
      ];
    },
  },
  methods: {
    formatNumber(value) {
      if (value == null || isNaN(value)) return 0;
      return Number.isInteger(value) ? value : value.toFixed(2);
    },
  }
}
</script>